import { Outlet, createFileRoute, linkOptions } from '@tanstack/react-router'
import { t } from 'i18next'
import {
  BarChart2,
  ChartNoAxesCombinedIcon,
  Shield,
  Target,
} from 'lucide-react'
import { useTranslation } from 'react-i18next'

import SectionLayout from '../-components/section-layout/section-layout'

export const Route = createFileRoute('/app/analysis')({
  component: RouteComponent,
})

const sidebarProps = {
  links: [
    {
      Icon: Shield,
      label: t('analysis.coverages.title'),
      link: linkOptions({ to: '/app/analysis/coverages' }),
      activeLink: '/app/analysis/coverages',
    },
    {
      Icon: Target,
      label: t('analysis.exposures.title'),
      link: linkOptions({ to: '/app/analysis/exposures' }),
      activeLink: '/app/analysis/exposures',
    },
    {
      Icon: ChartNoAxesCombinedIcon,
      label: t('analysis.insurers.title'),
      link: linkOptions({ to: '/app/analysis/insurers' }),
      activeLink: '/app/analysis/insurers',
    },
    {
      Icon: BarChart2,
      label: t('analysis.performance.title'),
      link: linkOptions({ to: '/app/analysis/performance' }),
      activeLink: '/app/analysis/performance',
    },
  ],
}

function RouteComponent() {
  const { t } = useTranslation()

  return (
    <SectionLayout title={t('analysis.title')} sidebarProps={sidebarProps}>
      <Outlet />
    </SectionLayout>
  )
}
